import { toast } from "../lib/toast";
import { stringToArray } from "./array";

import dayjs, { Dayjs } from "dayjs";

type EventValue<T> = T | null;
export type RangeValue<T> = [EventValue<T>, EventValue<T>] | null;

export type DateRange = {
  fromDate?: string;
  toDate?: string;
};

export function parseDateRange(dates: RangeValue<Dayjs>): DateRange {
  if (dates && dates[0] && dates[1]) {
    return {
      fromDate: dates[0].format("YYYY-MM-DD"),
      toDate: dates[1].format("YYYY-MM-DD"),
    };
  }
  return { fromDate: undefined, toDate: undefined };
}

export function toDayjsRange(dateRange: DateRange): RangeValue<Dayjs> {
  const { fromDate, toDate } = dateRange;
  if (fromDate && toDate) {
    return [dayjs(fromDate), dayjs(toDate)];
  }
  return null;
}

export function capitalize(value: string) {
  let capitalizedText = "";
  const conjunctions = [
    "an",
    "a",
    "the",
    "of",
    "and",
    "but",
    "for",
    "nor",
    "or",
    "so",
    "yet",
    "in",
    "on",
    "at",
    "to",
    "by",
    "with",
  ];

  const textArray = value?.split(" ");

  for (let i = 0; i < textArray?.length; i++) {
    let word = textArray[i];
    if (i === 0 || word?.endsWith(".")) {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    } else if (conjunctions?.includes(word?.toLowerCase())) {
      capitalizedText += word?.toLowerCase() + " ";
    } else {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    }
  }

  return capitalizedText?.trim();
}

export function returnFirstChar(value: string) {
  return value?.charAt(0)?.toUpperCase();
}

export function removeQuotesFromText(input: string) {
  return input?.replace(/"/g, "");
}

export function sliceUrl(str: string = "", size: number, dot?: string) {
  const splitStr = str?.split(".");
  splitStr.pop();
  const newStr = splitStr?.join();

  return newStr?.length > size
    ? `${newStr?.slice(0, size)}${dot || ""}`
    : newStr;
}

export const getExtension = (url: string) => {
  const file = stringToArray(url, ".") as string[];
  return file?.[file?.length - 1]?.toLowerCase();
};

export function formatUrl(url?: string): string | undefined {
  if (!url) return undefined;

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `https://${url}`;
}

export function parseJSON(val: string) {
  try {
    return JSON.parse(val);
  } catch (error) {
    toast("error", "JSON parse fail");
    return null;
  }
}
export function formatValue(value: unknown, fallback = "N/A"): string {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    (typeof value === "number" && isNaN(value))
  ) {
    return fallback;
  }
  return String(value);
}

export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(" ");
}

export function removeUnderscore(value?: string): string {
  if (!value) return "";
  return value.split("_").join(" ");
}
